export enum OrgChartRoutesEnum {
  PROFILE_ROOT = 'PROFILE/:id',
  PROFILE_WITH_OVERVIEW = 'profile/:id/:profileId',
  STATIC_DATA_ROOT = 'static-data/:type/:id',
  STATIC_DATA_WITH_OVERVIEW = 'static-data/:type/:id/:staticDataType/:staticDataId',
}
